import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationHelperService, TranslationTestMode } from '@app/core/services/translation-helper.service';
import { AppConfig } from '@core/models/app-config';
import { AppLocale } from '@core/models/app-locale';
import { AppConfigService } from '@core/services/app-config.service';
import { AppLocaleService } from '@core/services/app-locale.service';
import { AuthService } from '@core/services/auth.service';
import { UserProfilesService } from '@core/services/user-profiles.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { TermsAndConditionsService } from '@shared/services/terms-and-conditions.service';
import { SubSink } from 'subsink';

@Component({
	selector: 'cass-core-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, OnDestroy {

	environment = environment;

	locales: AppLocale[] = [];
	selectedLocale: AppLocale | undefined = undefined;
	enableChatToPublishers: string[] | undefined = undefined

	constructor (
		public authService: AuthService,
		public appConfigService: AppConfigService,
		public userProfilesService: UserProfilesService,
		private _appLocaleService: AppLocaleService,
		private _termsAndConditionsService: TermsAndConditionsService,
		private _translateService: TranslateService,
		private _translationHelper: TranslationHelperService
	) { }

	private subs = new SubSink();

	ngOnInit(): void {

		this.subs.add(
			this._appLocaleService.currentLocale$.subscribe((appLocale: AppLocale | undefined) => {
				this.selectedLocale = appLocale;
			})
		);

		this.subs.add(
			this.appConfigService.config$.subscribe((appConfig: AppConfig | undefined) => {
				if (appConfig) {
					this.locales = appConfig.locales;
					this.enableChatToPublishers = appConfig.enableChatToPublishers
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	selectLocale(locale: AppLocale | undefined): void {
		if (locale) {
			this.selectedLocale = locale;
			if (locale.localeId) {
				this._appLocaleService.userSelectLocale(locale?.localeId);
			}
		}
	}

	testLanguageStrings(mode: TranslationTestMode) {
		this._translationHelper.setTestMode(mode, this._translateService);
	}

	showTermsAndConditionsDilaog(): void {
		this._termsAndConditionsService.displayTermsAndConditionsDialog();
	}
}
